import { useAtomValue } from "jotai";
import { useState } from "react";
import { IsMobileAtom } from "../../App";
import AllTools from "./BrieAITools/AllTools";
import Summarizer from "./BrieAITools/OpenAIPowered/Summarizer";
import NamedEntityRecognition from "./BrieAITools/OpenAIPowered/NamedEntityRecognition";
import SentimentAnalysis from "./BrieAITools/OpenAIPowered/SentimentAnalysis";
import { BrieAITool } from "../../types/BrieInterfaces";
import BrieDesktopSidebar from "./BrieComponents/BrieDesktopSidebar";
import BrieMobileSidebar from "./BrieComponents/BrieMobileSidebar";
import { useParams } from "react-router-dom";
import EmailGenerator from "./BrieAITools/OpenAIPowered/EmailGenerator";
import QuestionGenerator from "./BrieAITools/OpenAIPowered/QuestionGenerator";
import BrieQuestionGenerator from "./BrieAITools/BriePowered/BrieQuestionGenerator";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import AskYourPDF from "./BrieAITools/BriePowered/AskYourPDF";
import DomainMapper from "./BrieAITools/BriePowered/DomainMapper";
import { isBrieDisabledAtom } from "../../atoms/GlobalAtoms";
import AppEmptyState from "../../elements/AppEmptyState";

// TODO: Review Descriptions
const AITools: BrieAITool[] = [
  // Open AI Tools
  {
    key: "summarizer",
    title: "Summarizer",
    icon: "mdi mdi-file-document-check-outline",
    description: "Identify the key points and themes in your text",
    powered: "open-ai",
  },
  {
    key: "namedEntityRecognition",
    title: "Named Entity Recognition",
    icon: "mdi mdi-text-recognition",
    description: "Quickly identify and extract important information",
    powered: "open-ai",
  },
  {
    key: "sentimentAnalysis",
    title: "Sentiment Analysis",
    icon: "mdi mdi-robot-happy-outline",
    description: "Create data capture forms with AI",
    powered: "open-ai",
  },
  {
    key: "emailGenerator",
    title: "Email Generator",
    icon: "mdi mdi-email-fast-outline",
    description: "Quickly generate emails based on your input",
    powered: "open-ai",
  },
  {
    key: "questionGenerator",
    title: "Question Generator",
    icon: "mdi mdi-chat-question-outline",
    description: "Quickly generate questions based on your input",
    powered: "open-ai",
  },
  // Brie AI Tools
  // {
  //   key: "brieQuestionGenerator",
  //   title: "Question Generator",
  //   icon: "mdi mdi-chat-question-outline",
  //   description: "Quickly generate questions based on your input",
  //   powered: "brie",
  // },
  {
    key: "askYourPDF",
    title: "Ask Your PDF",
    icon: "mdi mdi-account-question",
    description: "Upload your PDF, input a question, get an answer.",
    powered: "brie",
  },
  {
    key: "domainMapper",
    title: "Domain Mapper",
    icon: "mdi mdi-relation-one-to-one",
    description: "Link contacts to campanies based on email domains.",
    powered: "brie",
  },
];

const Brie = () => {
  const smallScreen = useAtomValue(IsMobileAtom);
  const [open, setOpen] = useState(!smallScreen);
  const { tab } = useParams();
  const tabData = AITools.find((t) => t?.key === tab);
  const isBrieDisabled = useAtomValue(isBrieDisabledAtom);

  let AITool;

  switch (tab) {
    //Brie AI Tools
    case "brieQuestionGenerator":
      AITool = <BrieQuestionGenerator />;
      break;
    case "askYourPDF":
      AITool = <AskYourPDF />;
      break;
    case "domainMapper":
      AITool = <DomainMapper />;
      break;
    // Open AI Tools
    case "home":
      AITool = <AllTools tools={AITools} />;
      break;
    case "summarizer":
      AITool = <Summarizer />;
      break;
    case "namedEntityRecognition":
      AITool = <NamedEntityRecognition />;
      break;
    case "sentimentAnalysis":
      AITool = <SentimentAnalysis />;
      break;
    case "emailGenerator":
      AITool = <EmailGenerator createEmailButton={true} />;
      break;
    case "questionGenerator":
      AITool = <QuestionGenerator />;
      break;
    default:
      AITool = <AllTools tools={AITools} />;
      break;
  }

  if (isBrieDisabled === true)
    AITool = (
      <div className="d-flex justify-content-center">
        <AppEmptyState
          title="AI Tools Disabled"
          description="AI Tools are a paid GrowthCloud Feature."
          className="w-100"
          icon="mdi-robot"
        />
      </div>
    );

  return (
    <>
      <AppHelmet
        title={`${tabData?.title || "AI Tools Home"} - GrowthCloud.com`}
      />
      <div className={`d-flex w-100 ${smallScreen && "flex-column"}`}>
        {smallScreen ? (
          <BrieMobileSidebar open={open} setOpen={setOpen} AITools={AITools} />
        ) : (
          <BrieDesktopSidebar open={open} setOpen={setOpen} AITools={AITools} />
        )}
        {smallScreen && open ? (
          <></>
        ) : (
          <div className="d-flex w-100 justify-content-center align-items-center py-3">
            <div
              className="mx-3 mb-3 w-md-75"
              style={{
                maxHeight: "100%",
                width: smallScreen ? "100%" : "75%",
                minWidth: "300px",
              }}
            >
              {AITool}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Brie;
